import React, { useEffect, useState } from 'react';
import {
  DataGrid,
  GridColDef,
  GridRenderCellParams,
  GridRowParams,
  GridToolbar,
  GridValueGetterParams,
} from '@mui/x-data-grid';
import { AdminCashRegisterResponseLoad, useGetCashRegistersLazyQuery } from '../../graphql';

import BaseLayout from '../BaseLayout/BaseLayout';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';

export const CashRegisterListLayout: React.FC = () => {
  const navigate = useNavigate();
  const [page, setPage] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(10);
  const [rowCount, setRowCount] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(true);
  const [search, setSearch] = useState('');
  const [cashRegisters, setCashRegisters] = useState<AdminCashRegisterResponseLoad[]>([]);
  const [cashRegisterQuery] = useGetCashRegistersLazyQuery();

  const fetchData = (page: number, pageSize: number, search: string) => {
    setLoading(true);
    cashRegisterQuery({
      variables: {
        page,
        pageSize,
        search,
      },
    }).then(response => {
      setLoading(false);
      setCashRegisters(response.data?.getCashRegisters?.cashRegisters ?? []);
      setRowCount(response.data?.getCashRegisters.total || 0);
    });
  };

  useEffect(() => {
    fetchData(page, pageSize, search);
  }, [page, pageSize, search]);

  const columns: GridColDef[] = [
    {
      field: 'cashRegister.id',
      headerName: 'ID',
      flex: 1,
      valueGetter: (params: GridValueGetterParams) => params.row.cashRegister.id,
    },
    {
      field: 'cashRegister.user.id',
      headerName: 'Issuer user',
      flex: 1,
      valueGetter: (params: GridValueGetterParams) => params.row.cashRegister.user.id,
    },
    {
      field: 'cashRegister.user.email',
      headerName: 'issuer email',
      valueGetter: (params: GridValueGetterParams) => params.row.cashRegister.user.email,
      flex: 1,
    },
    {
      field: 'mmm',
      headerName: 'Open Merchant',
      flex: 1,
      renderCell: (params: GridRenderCellParams<GridRowParams>) => (
        <Button
          href={`https://service-payment.paidapp.id/paidapp_admin/merchant_detail.jsf?merchant_id=${params.row.merchantId}`}
          target={'_blank'}
          referrerPolicy={'no-referrer'}
          variant="outlined">
          Open Merchant
        </Button>
      ),
    },
    {
      field: 'nnn',
      headerName: 'Open Receipt',
      flex: 1,
      renderCell: (params: GridRenderCellParams<GridRowParams>) => (
        <Button
          onClick={() => navigate(`/receipt?id=${params.row.cashRegister.id}`)}
          href="#"
          referrerPolicy={'no-referrer'}
          variant="outlined">
          Open Receipt
        </Button>
      ),
    },
    {
      field: 'cashRegister.reference',
      headerName: 'Reference',
      flex: 1,
      valueGetter: (params: GridValueGetterParams) => params.row.cashRegister.reference,
    },
    {
      field: 'cashRegister.cashRegisterNumber',
      headerName: 'Receipt Number',
      flex: 1,
      valueGetter: (params: GridValueGetterParams) => params.row.cashRegister.cashRegisterNumber,
    },
    {
      field: 'cashRegister.total',
      headerName: 'Total',
      flex: 1,
      valueGetter: (params: GridValueGetterParams) => params.row.cashRegister.total,
    },
    {
      field: 'cashRegister.fulfilled',
      headerName: 'Is fulfilled?',
      flex: 1,
      valueGetter: (params: GridValueGetterParams) => params.row.cashRegister.fulfilled,
    },
    {
      field: 'cashRegister.includeFees',
      headerName: 'Include fee ?',
      flex: 1,
      valueGetter: (params: GridValueGetterParams) => params.row.cashRegister.includeFees,
    },
    {
      field: 'cashRegister.updatedAt',
      headerName: 'Updated at',
      flex: 1,
      valueGetter: (params: GridValueGetterParams) =>
        moment.utc(params.row.cashRegister.updatedAt).format('YYYY.MM.DD HH:mm'),
    },
  ];

  return (
    <BaseLayout drawer={true}>
      <DataGrid
        components={{ Toolbar: GridToolbar }}
        componentsProps={{
          toolbar: {
            showQuickFilter: true,
            quickFilterProps: { debounceMs: 500 },
          },
        }}
        loading={loading}
        autoHeight
        rows={cashRegisters}
        columns={columns}
        page={page}
        pageSize={pageSize}
        rowCount={rowCount}
        pagination
        paginationMode="server"
        onPageChange={newPage => setPage(newPage)}
        onPageSizeChange={newPageSize => {
          setPageSize(newPageSize);
          setPage(0);
        }}
        onFilterModelChange={model => {
          const value = model.quickFilterValues?.[0] || '';
          setSearch(value);
          setPage(0);
        }}
      />
    </BaseLayout>
  );
};
